import React, { useMemo } from 'react'
import moment from 'moment'
import { CartesianGrid, Legend, Line, LineChart, XAxis, YAxis } from 'recharts'
import R from 'ramda'
const OperationalTruwupLineGraphMWSchedule = ({
  width = 730,
  height = 250,
  tdata = {},
  startDate = moment('2024-01-01'),
  endDate = moment('2024-01-30'), // put +1 days
}) => {
  const { daAward = [], genMW = [], euor = [], outage = [] } = tdata

  const parseIntFunc = val => parseInt(val)

  const daGroup = useMemo(
    _ =>
      R.compose(
        R.fromPairs,
        R.map(d => [d.dateTime, parseIntFunc(d.value1)])
      )(daAward),
    [daAward]
  )

  const genMwGroup = useMemo(
    _ =>
      R.compose(
        R.fromPairs,
        R.map(d => [d.dateTime, parseIntFunc(d.value1)])
      )(genMW),
    [genMW]
  )

  const euorGroup = useMemo(
    _ =>
      R.compose(
        R.fromPairs,
        R.map(d => [d.dateTime, parseIntFunc(d.value1)])
      )(euor),
    [euor]
  )

  const outageGroup = useMemo(
    _ =>
      R.compose(
        R.fromPairs,
        R.map(d => [d.dateTime, parseIntFunc(d.value1)])
      )(outage),
    [outage]
  )

  const data = useMemo(
    _ => {
      const effStartMoment = moment(startDate).clone()
      const effEndDate = moment(endDate).clone()
      const dateFormat = 'YYYY-MM-DDTHH:mm:ss.SSS'
      const odata = []
      while (effStartMoment.isSameOrBefore(effEndDate)) {
        const f = effStartMoment.format(dateFormat)
        const dt = {
          date: effStartMoment.toDate().getTime(),
          outage: outageGroup[f],
          genMW: genMwGroup[f],
          daAward: daGroup[f],
          euor: euorGroup[f],
        }
        odata.push(dt)
        effStartMoment.add(1, 'hour')
      }
      return odata
    },
    [daGroup, endDate, euorGroup, genMwGroup, outageGroup, startDate]
  )

  return (
    <div>
      <div
        style={{ paddingLeft: '10%', fontSize: '20px', textAlign: 'center' }}
      >
        MW Schedule
      </div>
      <LineChart
        height={height}
        width={width}
        data={data}
        margin={{ top: 5, right: 30, left: 20, bottom: 10 }}
        title="Title"
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis
          dataKey="date"
          scale="time"
          tickFormatter={d => moment(d).format('MM/DD')}
        />
        <YAxis
          yAxisId="yaxis"
          type="number"
          scale="auto"
          // domain={[0, 'auto']}
          allowDataOverflow
        />
        {/* <Tooltip /> */}
        <Legend align="center" verticalAlign="bottom" />
        <Line
          type="line"
          dataKey="daAward"
          stroke="orange"
          yAxisId="yaxis"
          name="DA Award"
          dot={false}
        />
        <Line
          type="line"
          dataKey="genMW"
          stroke="green"
          yAxisId="yaxis"
          name="Gen MW"
          dot={false}
        />
        <Line
          type="line"
          dataKey="euor"
          stroke="blue"
          yAxisId="yaxis"
          name="EUOR"
          dot={false}
        />
        <Line
          type="line"
          dataKey="outage"
          stroke="red"
          yAxisId="yaxis"
          name="Outage"
          dot={false}
        />
      </LineChart>
    </div>
  )
}

export default OperationalTruwupLineGraphMWSchedule
